import React from "react";
import Link from "helpers/link";
import Image from "components/image";
import ArrowRight from "images/arrow-right-green.png";
import { formatDate } from "helpers/formatDate";

const MainHeadliner = ({ data }) => {
  if (data.handle)
    return (
      <div>
        <div className="relative">
          <img
            src={data.image?.src}
            alt={data.image?.alt}
            className="w-full object-cover h-[500px] sm:h-[300px]"
          />
          <span className="absolute top-5 left-4 py-3 px-5 block bg-gray-800 bg-opacity-40 rounded-3xl">
            <h4 className="font-sans font-medium text-sm text-gray-100">
              {data.categories[0].title}
            </h4>
          </span>
        </div>
        <div className="bg-white max-w-[900px] sm:mx-2.5 rounded-md py-9 px-12 sm:py-4 sm:px-8 mx-auto -translate-y-1/3 -mb-28">
          <div className="flex items-center justify-start sm:justify-between">
            <h3 className="paragraph text-gray-800 mr-20 sm:mr-0">
              {data.author}
            </h3>
            <span className="paragraph text-gray-600">
              {formatDate(data.date)}
            </span>
          </div>
          <h2 className="header !text-indigo-800 mt-3.5 sm:text-h3">
            {data.title}
          </h2>
          <p className="paragraph text-gray-700 mt-8 mb-3.5">
            {data.description}
          </p>
          <Link
            to={`${data.handle.current}`}
            className="flex items-center gap-2.5 paragraph text-green-700 py-3"
          >
            Read more
            <img src={ArrowRight} alt="arrow right" className="w-6 h-6" />
          </Link>
        </div>
        <div className="h-0.5 w-full bg-gray-300 mt-9" />
      </div>
    );
};

export default MainHeadliner;
